import { NUM_IMPROVISERS_CHANGED } from './actions'

export const numImprovisers = (state = 0, action) => {
    switch (action.type) {

        case NUM_IMPROVISERS_CHANGED:
                return action.numImprovisers
    
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/numImprovisers/index.js